import Polygon from "./polygon"
import Calc from "@/common/util/calculator"

export default class StarForm extends Polygon {
  protected points(width: number, height: number) {
    return this.drawables.star(this.state.shape, width, height)
  }

  protected get baseRounding() {
    return this.calcRounding()
  }

  protected get cutlineRounding() {
    return this.printCutlineRounding(this.calcRounding())
  }

  private calcRounding() {
    return this.state.shape === "stop" && this.signType == "aluminium_sign" ? Calc.mmToPx(0.6) : 0
  }
}
